export class CodeValue {
  constructor(
    public code: string,
    public value: string,
    public codeValue: string,
  ) {}
}
